// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

class Content extends React.Component {
	render() {
		const { page } = this.props

		if ( ! page || ! page.content.rendered ) {
			return null
		}

		const content = (
			<div className="page-section">
				{ ( 'event' == page.post_type && page.featured_image && page.featured_image.url ) &&
					<img
						className="event-image"
						alt={ page.featured_image.alt }
						src={ page.featured_image.url }
						srcSet={ page.featured_image.srcset }
						sizes="100vw"
					/>
				}

				<div className='content-body-text' dangerouslySetInnerHTML={ { __html: page.content.rendered } }></div>

				{ page.notes && page.notes.rendered &&
					<div className='content-notes' dangerouslySetInnerHTML={ { __html: page.notes.rendered } }></div>
				}

				{ !! ( page.tags && page.tags.length ) &&
					<div className="content-tags">
						<h5>Tags</h5>

						<div className="content-tags-items">
							{ page.tags.map( item => {
								return <div className="-tag">{ item }</div>
							} ) }
						</div>
					</div>
				}
			</div>
		)

		return (
			<div className="content-body-wrap">
				<div className="content-body">
					{ content }
				</div>

				<div className="content-side">

				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Content )
